import { FC } from 'react'

import { formatCountLSD } from 'utils/formatCountLSD.ts'

import s from './s.module.scss'

type Props = {
  vestedBalance: string
}

const Vested: FC<Props> = ({ vestedBalance }) => (
  <div className={s.vestedBlock}>
    <div className={s.vestedHeader}>
      <div className={s.lsd}>{formatCountLSD(vestedBalance)} LSD</div>
      total allocated for you
    </div>
    <div className={s.vestedDescription}>Collect your reward one time per month</div>
  </div>
)

export default Vested
